export default "__VITE_ASSET__fTZGhWZ$__"